import http from '@/utils/http' //引入axios
export const getRecycletype = data => http.get('/rvm-center/api/recycletype', {
    params: data
}) //查找条码
export const updataRecycletype = data => http.put('/rvm-center/api/recycletype', data) //編輯条码
export const addRecycletype = data => http.post('/rvm-center/api/recycletype', data) //添加条码
export const deleteRecycletype = data => http.delete('/rvm-center/api/recycletype', {
    params: data
}) //根据barcodes刪除条码
// export  const findBarcode = data=>http.get('/api/district/superior',{params:data}) //查找部门
export default {
    getRecycletype,
    updataRecycletype,
    addRecycletype,
    deleteRecycletype,
    // findBarcode
}